import { Component, Vue, Watch } from 'vue-property-decorator';

import { dateStrToFormat } from '@/filters/index';
import { OnlineResMgr } from '@/api/index';
import BaseInfo from '@/components/base-info.vue'; // 基本信息组件

@Component({
  components: {
    BaseInfo
  }
})
export default class OnlineResDetailMgr extends Vue {
  private currentResId: string = ''; // 当前资源Id
  private currentResource: any = {}; // 当前资源信息
  private dicts: any = {
    province: {},
    vCity: {},
    resource_status_online: {},
    classify: {},
    manufacturer: {}
  }; // 字典表
  private created() {
    this.currentResId = this.$route.params.id;
    this.getCurrentResData();
    this.getDicts();
    this.getVprovinceDict();
    this.getVcityDict();
  }
  // 获取当前资源信息
  private getCurrentResData() {
    OnlineResMgr.getResourceById(this.currentResId).then(res => {
      this.currentResource = res.data;
    });
  }
  // 初始化设置数据
  get currentResData() {
    return {
      center: [
        { label: '设备名称', value: this.currentResource.deviceName },
        { label: '设备型号', value: this.currentResource.deviceType },
        { label: '板卡型号', value: this.currentResource.pid },
        { label: '序列号', value: this.currentResource.serialNumber },
        { label: '设备Loopback0', value: this.currentResource.manageIp },
        { label: '槽位', value: this.currentResource.slot },
        {
          label: '硬件归类',
          value: this.dicts.classify[this.currentResource.classify] || this.currentResource.classify
        },
        {
          label: '硬件状态',
          value: this.dicts.resource_status_online[this.currentResource.status] || this.currentResource.status
        },
        {
          label: '厂商',
          value: this.dicts.manufacturer[this.currentResource.manufacturer] || this.currentResource.manufacturer
        },
        { label: '硬件描述', value: this.currentResource.description },
        { label: '板卡软件版本', value: this.currentResource.vid },
        {
          label: '所属省份',
          value: this.dicts.province[this.currentResource.provinceId] || this.currentResource.provinceId
        },
        {
          label: '所属地市',
          value: this.dicts.vCity[this.currentResource.cityId] || this.currentResource.cityId
        },
        { label: '所属机房', value: this.currentResource.room },
        { label: '存放位置', value: this.currentResource.location },
        { label: 'EOS', value: this.currentResource.eos },
        { label: '所属工程', value: this.currentResource.projectId },
        {
          label: '工程终验日期',
          value: dateStrToFormat(this.currentResource.projectCompleteTime )
        },
        { label: '工程合同名称', value: this.currentResource.projectContractName }
      ],
      right: [
        { label: '电子运维单号', value: this.currentResource.eomsNumber },
        { label: '投资类型', value: this.currentResource.investmentType },
        { label: '投资金额 ', value: this.currentResource.investmentMoney },
        { label: '转固资产序号 ', value: this.currentResource.propertyNumber },
        { label: '资产卡片号 ', value: this.currentResource.propertyCardNumber },
        { label: '实物编码 ', value: this.currentResource.entityNumber },
        {
          label: '首次入网时间',
          value: dateStrToFormat(this.currentResource.accessNetworkTime)
        },
        { label: '出场时间', value: dateStrToFormat(this.currentResource.manufactureTime) }
      ]
    };
  }
  // 获取字典表
  private getDicts() {
    const array = [ 'classify', 'resource_status_online', 'manufacturer' ];
    for (const item of array) {
      OnlineResMgr.getDicts(item).then(dict => {
        for (const v of dict.data) {
          this.$set(this.dicts[item], v.value, v.displayName);
        }
      });
    }
  }
  // 获取省份
  private getVprovinceDict() {
    OnlineResMgr.getVprovinceList('', '').then(res => {
      for (const item of res.data) {
        this.$set(this.dicts.province, item.id, item.vProvinceName);
      }
    });
  }
  // 获取地市
  private getVcityDict() {
    OnlineResMgr.getVcityList('', '').then(res => {
      for (const item of res.data) {
        this.$set(this.dicts.vCity, item.id, item.vCityName);
      }
    });
  }
}
